import { gql } from 'graphql-tag';

export const INTERNAL_LINK_FRAGMENT = gql`
    fragment INTERNAL_LINK_FRAGMENT on InternalLink {
        category
        geo
        propertyType
        section
        transactionType
        uri
    }
`;
